'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Pin';

var EntypoPin = function EntypoPin(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M4.774,15.287l-2.105,3.25L2.893,19.6l1.06-0.227l2.104-3.248c-0.224-0.12-0.446-0.248-0.661-0.39C5.178,15.594,4.97,15.443,4.774,15.287z M13.686,14.152c0.014-0.029,0.023-0.061,0.036-0.092c0.053-0.117,0.1-0.234,0.138-0.357c0.006-0.022,0.009-0.044,0.016-0.064c0.039-0.136,0.072-0.27,0.098-0.408c0-0.007,0-0.012,0-0.021c0.195-1.169-0.145-2.473-0.923-3.651l1.11-1.714c1.279,0.163,2.385-0.159,2.917-0.982c0.923-1.423-0.2-3.792-2.505-5.293c-2.307-1.502-4.923-1.565-5.844-0.144C8.195,2.25,8.351,3.393,9.022,4.499L7.91,6.213c-1.389-0.233-2.716-0.016-3.703,0.64C4.201,6.855,4.194,6.857,4.19,6.861C4.075,6.939,3.963,7.025,3.858,7.115C3.841,7.129,3.821,7.142,3.807,7.156C3.709,7.24,3.621,7.334,3.536,7.428c-0.02,0.024-0.048,0.045-0.067,0.07C3.363,7.619,3.265,7.747,3.179,7.883c-1.384,2.133-0.203,5.361,2.633,7.209c2.838,1.848,6.26,1.614,7.641-0.519C13.54,14.438,13.62,14.297,13.686,14.152z M12.871,4.194c-0.887-0.577-1.32-1.487-0.965-2.036c0.354-0.547,1.361-0.522,2.246,0.055c0.889,0.577,1.318,1.489,0.965,2.036C14.764,4.796,13.759,4.771,12.871,4.194z' })
    );
};

exports.default = EntypoPin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Pin.js
// module id = ./node_modules/react-entypo/lib/entypo/Pin.js
// module chunks = 2